import { Injectable } from '@angular/core';

import * as appConstants from '@app/constants';
// Interfaces
import { Countries, States } from '@app/interfaces';


@Injectable({
    providedIn: 'root'
})

export class AppDataService {
    private _countriesList: Array<Countries> = [];
    private _statesList: Array<States> = [];

    public setCountriesList(countriesList: Array<Countries>): void {
        this._countriesList = [...countriesList];
    }

    public setStatesList(statesList: Array<States>): void {
        this._statesList = [...statesList ];
    }

    get countriesList(): Array<Countries> {
        return this._countriesList;
    }

    get statesList(): Array<States> {
        return this._statesList;
    }

    public getStatesListByCountryId(countryId = appConstants.DEFAULT_COUNTRY): Countries {
        return [...this.countriesList].find(country => country.id === countryId);
    }
}
